import { useSections } from "@/contexts/classified";
export const useNewBuild = () => {
    var _a;
    const { projectLink, logo, title } = ((_a = useSections()) === null || _a === void 0 ? void 0 : _a.newBuild) || {};
    return { projectLink, logo, title, display: !!projectLink };
};
